module.exports = __webpack_public_path__ + "assets/paymill.f5e9c62d.svg";